//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';
import { TeacherCalendarPreferencesUpdateItem } from './TeacherCalendarPreferencesUpdateItem';
import { TeacherCalendarFeedPreferencesUpdateItem } from './TeacherCalendarFeedPreferencesUpdateItem';
import { TeacherEmailPreferencesUpdateItem } from './TeacherEmailPreferencesUpdateItem';
import { TeacherAttendancePreferencesUpdateItem } from './TeacherAttendancePreferencesUpdateItem';
import { TeacherBookingPreferencesUpdateItem } from './TeacherBookingPreferencesUpdateItem';
import { TeacherNavigationPreferencesUpdateItem } from './TeacherNavigationPreferencesUpdateItem';
import { IEmailUpdate } from './IEmailUpdate';
import { InvoiceFormat } from './Enums';

export class TeacherProfileUpdateItem extends ItemBase implements IEmailUpdate {
    Address?: string | null;
    EmailAddress?: string | null;
    FirstName?: string | null;
    LastName?: string | null;
    SpokenLanguages?: string[];
    TelephoneNumber?: string | null;
    Title?: string | null;
    ZoomMeetingURL?: string | null;
    ShowSetupGuide?: boolean;
    CalendarPreferences?: TeacherCalendarPreferencesUpdateItem | null;
    CalendarFeedPreferences?: TeacherCalendarFeedPreferencesUpdateItem | null;
    EmailPreferences?: TeacherEmailPreferencesUpdateItem | null;
    AttendancePreferences?: TeacherAttendancePreferencesUpdateItem | null;
    BookingPreferences?: TeacherBookingPreferencesUpdateItem | null;
    NavigationPreferences?: TeacherNavigationPreferencesUpdateItem | null;
    InvoiceFormatPreference?: InvoiceFormat;
    UseBetaTeacherPortal?: boolean;
    TimeZoneID?: string | null;

    constructor(initializer?: Partial<TeacherProfileUpdateItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "TeacherProfileUpdateItem";
}
